export const getOptionSelected = (option, value) => option.value === value.value;
export const getOptionLabel = option => {
  if (!option) return '';
  return typeof option === 'string' ? option : option.label;
};